import { productAtom } from "core/catalog";
import { cn } from "core/shared";
import { BaseLink, ChevronRight } from "~/design-system/components";

export function ProductDetailsBreadcrumb() {
  const breadcrumbs = productAtom.use("breadcrumbs");

  return (
    <ul className="my-6 flex flex-wrap items-center gap-2 text-base sm:text-lg xl:text-xl">
      {breadcrumbs.map((breadcrumb, index) => (
        <li
          key={index}
          className={cn(
            "text-opacity-50 flex items-center gap-2 text-black",
            index < breadcrumbs.length - 1 ? "text-black/50" : "text-black",
          )}
        >
          {breadcrumb.url ? (
            <BaseLink to={breadcrumb.url}>{breadcrumb.text}</BaseLink>
          ) : (
            <span>{breadcrumb.text}</span>
          )}
          <span
            className={cn(
              index < breadcrumbs.length - 2 ? "text-black/50" : "text-black",
              index === breadcrumbs.length - 1 && "hidden",
            )}
          >
            <ChevronRight />
          </span>
        </li>
      ))}
    </ul>
  );
}
